import { render, staticRenderFns } from "./MoveToDialog.vue?vue&type=template&id=78201648"
import script from "./MoveToDialog.vue?vue&type=script&lang=ts"
export * from "./MoveToDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78201648')) {
      api.createRecord('78201648', component.options)
    } else {
      api.reload('78201648', component.options)
    }
    module.hot.accept("./MoveToDialog.vue?vue&type=template&id=78201648", function () {
      api.rerender('78201648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialogs/MoveToDialog.vue"
export default component.exports